//  Visual ellipsis to indicate that there are more pages.
const PaginationEllipsis = () => (
  <div className="fossa-pagination__ellipsis">
    ...
  </div>
);

export default PaginationEllipsis;
